import React from "react";
import OrderSummaryCard from "./OrderSummaryCard";

const OrderConfirmation = (data) => {

  const orderData = data.orderData;
  return (
    <div
      style={{
        minHeight: "100vh",
        backgroundColor: "#f9fafb",
        padding: "1rem",
      }}
    >
      {/* Header */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginBottom: "1.5rem",
        }}
      >
        <button style={{ color: "#6b7280" }}>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M19 12H5M12 19l-7-7 7-7" />
          </svg>
        </button>
        <h1
          style={{
            textAlign: "center",
            flexGrow: 1,
            fontSize: "1.25rem",
            fontWeight: "600",
            marginRight: "2rem",
          }}
        >
          Order Summary
        </h1>
      </div>


      {orderData.cards.map((item) => (

        < div >{item.cardType == 18 ? <div>
          <img src={item.cardData[0].data.imageUrl} style={{ width: '100%', objectFit: 'fill' }} />
        </div>
          : item.cardType == 116 ?
            < OrderSummaryCard card={item} />
            : ""
        }
        </div>

      ))
      }
    </div>
  );
};

export default OrderConfirmation;
